/* ==========================================================================
   Roll DTF — Blank vitrin davranışı (rb-*).
   Gerçek mod: bölümler Liquid'den gelen ürün verisini kullanır.
   Önizleme modu: Shopify'da henüz blank ürün yokken (ithalat öncesi) bölümler
   roll-blanks-demo.json'daki gerçek S&S verisiyle çizilir. ?rb_markup=1.50 ile
   önizleme fiyat çarpanı denenebilir (yalnız önizleme verisinde).
   ========================================================================== */
(function () {
  "use strict";
  if (window.RollBlanks) return;
  var BUYUK = ["2XL", "3XL", "4XL", "5XL", "6XL"];
  var qs = new URLSearchParams(location.search);
  var demoP = null;

  function h(tag, attrs, kids) {
    var e = document.createElement(tag);
    Object.keys(attrs || {}).forEach(function (k) {
      var v = attrs[k];
      if (v == null || v === false) return;
      if (k === "text") e.textContent = v;
      else if (k === "html") e.innerHTML = v;
      else if (k === "style") e.style.cssText = v;
      else if (k.slice(0, 2) === "on") e.addEventListener(k.slice(2), v);
      else e.setAttribute(k, v === true ? "" : v);
    });
    (kids || []).forEach(function (c) { if (c != null) e.appendChild(typeof c === "string" ? document.createTextNode(c) : c); });
    return e;
  }
  function money(x) { return x == null ? "—" : "$" + x.toFixed(2); }

  /* ---------- önizleme verisi ---------- */
  function demoUrl() { var e = document.querySelector("[data-rb-demo-url]"); return e ? e.getAttribute("data-rb-demo-url") : null; }
  function assetBase() { var u = demoUrl() || ""; return u.split("roll-blanks-demo.json")[0]; }
  function demo() {
    if (!demoP) {
      var u = demoUrl();
      demoP = u ? fetch(u, { credentials: "same-origin" }).then(function (r) { return r.json(); }) : Promise.reject(new Error("demo yok"));
    }
    return demoP;
  }
  function markup(d) {
    var m = parseFloat(qs.get("rb_markup"));
    return (m >= 1 && m <= 3) ? m : (d.default_markup || 1.3);
  }
  function raf(cost, m) { return cost == null ? null : Math.floor((cost * m * 100) / 10 + 0.5) * 10 / 100; }
  function img(name) { return name ? assetBase() + name : null; }

  /* ---------- ürün kartı (önizleme; gerçek kartlar Liquid'de aynı yapıda) ---------- */
  function demoCard(p, d, pdpBase) {
    var m = markup(d);
    var href = pdpBase ? pdpBase + encodeURIComponent(p.handle) + (qs.get("rb_markup") ? "&rb_markup=" + qs.get("rb_markup") : "") : "#";
    return h("a", { class: "rb-card", href: href, "data-vendor": p.vendor, "data-cat": p.cat }, [
      h("span", { class: "rb-card__img" }, [h("img", { src: img(p.img), alt: p.title, loading: "lazy", width: "600", height: "750" })]),
      h("span", { class: "rb-card__body" }, [
        h("span", { class: "rb-card__brand", text: p.vendor }),
        h("span", { class: "rb-card__title", text: p.title }),
        h("span", { class: "rb-card__price" }, [h("small", { text: "From " }), money(raf(p.c_min, m))]),
        h("span", { class: "rb-dots" }, p.hex.slice(0, 9).map(function (c) { return h("i", { style: "--c:" + c }); })
          .concat([h("span", { text: p.colors + " colors" })]))
      ])
    ]);
  }

  function fillDemo(root) {
    var rows = root.querySelectorAll("[data-rb-demo-row]");
    var cats = root.querySelectorAll("[data-rb-demo-cat]");
    var mins = root.querySelectorAll("[data-rb-demo-minprice]");
    var colls = root.querySelectorAll("[data-rb-collection][data-rb-demo]");
    var recs = root.querySelectorAll("[data-rb-demo-recs]");
    if (!rows.length && !cats.length && !mins.length && !colls.length && !recs.length) return;
    demo().then(function (d) {
      var m = markup(d);
      rows.forEach(function (el) {
        var cat = el.getAttribute("data-rb-demo-row"), n = parseInt(el.getAttribute("data-limit") || "4", 10);
        var list = d.products.filter(function (p) { return cat === "all" || p.cat === cat; }).slice(0, n);
        el.textContent = "";
        list.forEach(function (p) { el.appendChild(demoCard(p, d, el.getAttribute("data-pdp-base"))); });
      });
      cats.forEach(function (el) {
        var c = d.categories.filter(function (x) { return x.handle === el.getAttribute("data-rb-demo-cat"); })[0];
        if (c) el.textContent = c.count + (c.count === 1 ? " product" : " products");
      });
      var min = Math.min.apply(null, d.products.map(function (p) { return p.c_min; }));
      mins.forEach(function (el) { el.textContent = money(raf(min, m)); });
      colls.forEach(function (el) { renderDemoCollection(el, d); });
      recs.forEach(function (el) {
        var curKey = qs.get("rb_demo") || "gildan-5000", cur = d.pdp[curKey] || {};
        var same = d.products.filter(function (p) { return p.handle !== curKey && p.cat === cur.cat; });
        var other = d.products.filter(function (p) { return p.handle !== curKey && p.cat !== cur.cat; });
        el.textContent = "";
        same.concat(other).slice(0, 4).forEach(function (p) { el.appendChild(demoRec(p, d, el.getAttribute("data-pdp-base"))); });
      });
    }).catch(function () {});
  }

  /* ---------- koleksiyon (Bear blank koleksiyon düzeni) ---------- */
  var FIYAT_ARALIK = [["Under $5", 0, 5], ["$5 – $10", 5, 10], ["$10 – $20", 10, 20], ["$20 and up", 20, 1e9]];
  function renderDemoCollection(el, d) {
    var root = el.closest(".rb") || document, grid = el.querySelector("[data-rb-grid]"), m = markup(d);
    grid.textContent = "";
    d.products.forEach(function (p) {
      var pd = d.pdp[p.handle] || {}, fams = [];
      (pd.colors || []).forEach(function (c) { if (c.family && fams.indexOf(c.family) < 0) fams.push(c.family); });
      var card = demoRec(p, d, el.getAttribute("data-pdp-base"));
      card.setAttribute("data-cat", p.cat); card.setAttribute("data-vendor", p.vendor); card.setAttribute("data-type", p.type);
      card.setAttribute("data-price", String(raf(p.c_min, m))); card.setAttribute("data-title", p.title.toLowerCase());
      card.setAttribute("data-fams", fams.join("|")); card.setAttribute("data-sizes", (pd.sizes || []).join("|"));
      grid.appendChild(card);
    });
    // sayılar (haplar + döşemeler)
    root.querySelectorAll("[data-rb-cat-n]").forEach(function (e) {
      var h_ = e.getAttribute("data-rb-cat-n");
      e.textContent = String(h_ === "all" ? d.products.length : d.products.filter(function (p) { return p.cat === h_; }).length);
    });
    // marka hapları
    var bp = root.querySelector("[data-rb-brandpills]"), vendors = [];
    d.products.forEach(function (p) { if (vendors.indexOf(p.vendor) < 0) vendors.push(p.vendor); });
    if (bp) vendors.forEach(function (v) { bp.appendChild(h("button", { type: "button", class: "rb-pill rb-pill--sm", "data-brand": v, text: v })); });
    // filtreler
    var cards = Array.prototype.slice.call(grid.children);
    function uniq(attr, split) {
      var out = {};
      cards.forEach(function (c) { (split ? (c.getAttribute(attr) || "").split("|") : [c.getAttribute(attr)]).forEach(function (v) { if (v) out[v] = (out[v] || 0) + 1; }); });
      return out;
    }
    var bar = el.querySelector("[data-rb-filters]");
    var groups = [
      ["avail", "Availability", { "In stock": cards.length }],
      ["price", "Price", FIYAT_ARALIK.reduce(function (o, r) { o[r[0]] = cards.filter(function (c) { var x = parseFloat(c.getAttribute("data-price")); return x >= r[1] && x < r[2]; }).length; return o; }, {})],
      ["vendor", "Brand", uniq("data-vendor")],
      ["fams", "Color", uniq("data-fams", true)],
      ["sizes", "Size", uniq("data-sizes", true)],
      ["type", "Product Type", uniq("data-type")]
    ];
    groups.forEach(function (g) {
      var opts = Object.keys(g[2]).filter(function (k) { return g[2][k] > 0; });
      if (g[0] === "sizes") { var ORD = ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "6XL", "OSFA", "One Size"]; var rk = function (x) { var i = ORD.indexOf(x); return i < 0 ? 999 : i; }; opts.sort(function (a, b) { return rk(a) - rk(b); }); }
      bar.appendChild(h("details", { class: "rb-dd", "data-group": g[0] }, [
        h("summary", {}, [g[1], h("em", { "data-rb-dd-n": "" })]),
        h("div", { class: "rb-dd__p" }, opts.map(function (o) {
          return h("label", { class: "rb-dd__opt" }, [h("input", { type: "checkbox", value: o }), h("i"), o + " ", h("em", { text: String(g[2][o]) })]);
        }))
      ]));
    });
    bindCollection(el, true);
  }

  function bindCollection(el, isDemo) {
    var root = el.closest(".rb") || document, grid = el.querySelector("[data-rb-grid]");
    var cards = Array.prototype.slice.call(grid.querySelectorAll(".rb-rec, .rb-card"));
    var orig = cards.slice();
    var st = { cat: qs.get("rb_cat") || "all", q: "", sel: {} };
    if (qs.get("rb_brand")) st.sel.vendor = [qs.get("rb_brand")];
    var count = el.querySelector("[data-rb-count]"), empty = el.querySelector("[data-rb-empty]");

    function inRange(c, labels) {
      var x = parseFloat(c.getAttribute("data-price"));
      return labels.some(function (l) { var r = FIYAT_ARALIK.filter(function (z) { return z[0] === l; })[0]; return r && x >= r[1] && x < r[2]; });
    }
    function apply() {
      var n = 0;
      cards.forEach(function (c) {
        var ok = (!isDemo || st.cat === "all" || c.getAttribute("data-cat") === st.cat) &&
                 (!st.q || (c.getAttribute("data-title") || "").indexOf(st.q) >= 0 || (c.getAttribute("data-vendor") || "").toLowerCase().indexOf(st.q) >= 0);
        Object.keys(st.sel).forEach(function (g) {
          var vals = st.sel[g]; if (!ok || !vals || !vals.length) return;
          if (g === "price") ok = inRange(c, vals);
          else if (g === "avail") ok = true;
          else if (g === "fams" || g === "sizes") ok = vals.some(function (v) { return ("|" + (c.getAttribute("data-" + g) || "") + "|").indexOf("|" + v + "|") >= 0; });
          else ok = vals.indexOf(c.getAttribute("data-" + g)) >= 0;
        });
        c.hidden = !ok; if (ok) n++;
      });
      if (count && (isDemo || st.q)) count.textContent = String(n);
      if (empty) empty.hidden = n > 0;
      root.querySelectorAll("[data-rb-pills] [data-cat], .rb-tile[data-cat]").forEach(function (a) {
        if (isDemo) a.classList.toggle("is-on", a.getAttribute("data-cat") === st.cat);
      });
      root.querySelectorAll("[data-rb-brandpills] [data-brand]").forEach(function (b) {
        b.classList.toggle("is-on", (st.sel.vendor || []).indexOf(b.getAttribute("data-brand")) >= 0);
      });
      el.querySelectorAll(".rb-dd[data-group]").forEach(function (dd) {
        var g = dd.getAttribute("data-group"), vals = st.sel[g] || [];
        dd.querySelectorAll("input").forEach(function (i) { i.checked = vals.indexOf(i.value) >= 0; });
        var e = dd.querySelector("[data-rb-dd-n]"); if (e) e.textContent = vals.length ? String(vals.length) : "";
        dd.classList.toggle("is-active", vals.length > 0);
      });
    }
    if (isDemo) {
      root.querySelectorAll("[data-rb-pills] a[data-cat], .rb-tile[data-cat]").forEach(function (a) {
        a.addEventListener("click", function (e) { e.preventDefault(); st.cat = a.getAttribute("data-cat") || "all"; apply();
          if (a.classList.contains("rb-tile")) el.scrollIntoView({ behavior: "smooth", block: "start" }); });
      });
      root.querySelectorAll("[data-rb-brandpills] [data-brand]").forEach(function (b) {
        b.addEventListener("click", function () { var v = b.getAttribute("data-brand"), cur = st.sel.vendor || [];
          st.sel.vendor = cur.indexOf(v) >= 0 ? cur.filter(function (x) { return x !== v; }) : cur.concat([v]); apply(); });
      });
      el.querySelectorAll(".rb-dd[data-group] input").forEach(function (i) {
        i.addEventListener("change", function () {
          var g = i.closest(".rb-dd").getAttribute("data-group"), cur = st.sel[g] || [];
          st.sel[g] = i.checked ? cur.concat([i.value]) : cur.filter(function (x) { return x !== i.value; }); apply();
        });
      });
      var top = root.querySelector("[data-rb-search]");
      if (top) top.addEventListener("submit", function (e) { e.preventDefault(); var v = top.querySelector("input[name=q]").value.trim().toLowerCase();
        st.q = v; var qi = el.querySelector("[data-rb-q]"); if (qi) qi.value = v; apply(); el.scrollIntoView({ behavior: "smooth", block: "start" }); });
    }
    var qi = el.querySelector("[data-rb-q]");
    if (qi) qi.addEventListener("input", function () { st.q = qi.value.trim().toLowerCase(); apply(); });
    // açılır menüler: biri açılınca diğerleri kapansın, dışarı tıklayınca kapansın
    var dds = el.querySelectorAll(".rb-dd");
    dds.forEach(function (dd) { dd.addEventListener("toggle", function () { if (dd.open) dds.forEach(function (o) { if (o !== dd) o.open = false; }); }); });
    document.addEventListener("click", function (e) { if (!e.target.closest(".rb-dd")) dds.forEach(function (o) { o.open = false; }); });
    // sıralama
    var sort = el.querySelector("[data-rb-sort]");
    if (sort) sort.addEventListener("change", function () {
      if (sort.hasAttribute("data-real")) { var u = new URL(location.href); u.searchParams.set("sort_by", sort.value); u.searchParams.delete("page"); location.href = u.toString(); return; }
      var list = orig.slice(), v = sort.value;
      var pr = function (c) { return parseFloat(c.getAttribute("data-price")) || 0; }, tt = function (c) { return c.getAttribute("data-title") || ""; };
      if (v === "price-asc") list.sort(function (a, b) { return pr(a) - pr(b); });
      if (v === "price-desc") list.sort(function (a, b) { return pr(b) - pr(a); });
      if (v === "az") list.sort(function (a, b) { return tt(a) < tt(b) ? -1 : 1; });
      if (v === "za") list.sort(function (a, b) { return tt(a) > tt(b) ? -1 : 1; });
      list.forEach(function (c) { grid.appendChild(c); });
    });
    // görünüm
    el.querySelectorAll("[data-rb-view]").forEach(function (b) {
      b.addEventListener("click", function () {
        el.querySelectorAll("[data-rb-view]").forEach(function (x) { x.classList.toggle("is-on", x === b); });
        grid.classList.toggle("rb-grid--list", b.getAttribute("data-rb-view") === "list");
      });
    });
    apply();
  }

  /* ---------- ürün sayfası (Bear blank PDP düzeni, Roll renkleri) ---------- */
  var POPULER = ["Black", "White", "Sport Grey", "Navy", "Red", "Royal", "Charcoal", "Forest Green", "Maroon", "Heather Grey"];
  var SVG = {
    fabric: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M4 4h16v16H4z"/><path d="M4 9h16M4 14h16M9 4v16M14 4v16"/></svg>',
    weight: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 9h12l2 11H4z"/><circle cx="12" cy="6" r="2.5"/></svg>',
    fit: '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M8 3l-5 4 3 4 2-1v11h8V10l2 1 3-4-5-4c-1 2-2.5 3-4 3S9 5 8 3z"/></svg>',
    tag: '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><path d="M3 12V4h8l10 10-8 8z"/><circle cx="7.5" cy="8.5" r="1.3"/></svg>',
    x: '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    truck: '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M3 6h11v9H3zM14 9h4l3 3v3h-7z"/><circle cx="7" cy="17.5" r="1.7"/><circle cx="17" cy="17.5" r="1.7"/></svg>',
    doc: '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M6 3h9l4 4v14H6z"/><path d="M9 11h7M9 15h7"/></svg>',
    list: '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"><path d="M9 6h11M9 12h11M9 18h11M4 6h.01M4 12h.01M4 18h.01"/></svg>',
    ruler: '<svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8"><path d="M3 8h18v8H3z"/><path d="M7 8v3M11 8v4M15 8v3M19 8v4"/></svg>'
  };
  function cellFrom(list) {
    var c = {};
    (list || []).forEach(function (x) { if (x && x.id) c[x.s] = { price: x.p / 100, qty: x.q, avail: !!x.a, id: x.id }; });
    return c;
  }
  // Shopify 250+ varyantlı üründe seçenek sırasını değiştirmiyor (productOptionsReorder etkisiz):
  // S&S XS'i 3XL'den sonra vermişse ızgara burada dizilir. Bilinmeyen beden (şapka M/L) varsa dokunma.
  var BEDEN = ["XS", "S", "M", "L", "XL", "2XL", "3XL", "4XL", "5XL", "6XL", "OSFA", "One Size"];
  function bedenSirala(list) {
    list = list || [];
    if (!list.every(function (x) { return BEDEN.indexOf(x) > -1; })) return list;
    return list.slice().sort(function (a, b) { return BEDEN.indexOf(a) - BEDEN.indexOf(b); });
  }
  function modelFromReal(r, sectionUrl) {
    var meta = {}, cell = {};
    (r.colors_meta || []).forEach(function (c) { if (c && c.name) meta[c.name] = c; });
    var colors = r.color_values.map(function (c) {
      var mt = meta[c.name] || {};
      // mt.front S&S'in sunucusunda: S&S Cross-Origin-Resource-Policy ile başka sitede göstermeyi
      // engelliyor (kırık görsel). Yalnız Shopify'daki varyant görseli; yoksa renk yüklenince gelir.
      return { name: c.name, hex: mt.hex || "", hex2: mt.hex2 || "", family: mt.family || "", img: c.img || null, variant: c.var, oid: c.oid };
    });
    cell[r.selected_color] = cellFrom(r.cur);
    var pending = {};
    function load(color) {
      if (cell[color]) return Promise.resolve();
      if (pending[color]) return pending[color];
      var c = colors.filter(function (x) { return x.name === color; })[0];
      // 'var' seçili bedene bağlı: renkte o beden yoksa boş gelir. O zaman rengin değer kimliğiyle
      // (option_values) yüklenir — yoksa rengin bütün bedenleri N/A kalıyordu (28.10.2026 denetimi).
      var q = c && (c.variant ? "&variant=" + c.variant : (c.oid ? "&option_values=" + c.oid : ""));
      if (!q || !sectionUrl) { cell[color] = {}; return Promise.resolve(); }
      pending[color] = fetch(sectionUrl + q, { credentials: "same-origin" })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var js = new DOMParser().parseFromString(html, "text/html").querySelector("script[data-rb-product]");
          var d = js ? JSON.parse(js.textContent) : null;
          cell[color] = d ? cellFrom(d.cur) : {};
          if (d && !c.img) { var im = (d.cur || []).filter(function (x) { return x && x.img; })[0]; if (im) c.img = im.img; }
        })
        .catch(function () { cell[color] = {}; });
      return pending[color];
    }
    return { real: true, title: r.title, vendor: r.vendor, type: r.type, desc: r.desc, colors: colors, sizes: bedenSirala(r.size_values),
             cell: cell, load: load, gallery: r.images || [], defaultColor: r.selected_color, specs: r.specs, chart: r.chart,
             priceMin: r.price_min / 100, priceMax: r.price_max / 100, modelImg: (r.images || [])[0] || null };
  }
  function modelFromDemo(p, d) {
    var m = markup(d), cell = {}, lo = null, hi = null;
    Object.keys(p.m).forEach(function (c) {
      cell[c] = {};
      Object.keys(p.m[c]).forEach(function (s) {
        var x = p.m[c][s], pr = raf(x[0], m);
        cell[c][s] = { price: pr, qty: x[1], avail: x[1] > 5, id: null };
        if (pr != null) { if (lo == null || pr < lo) lo = pr; if (hi == null || pr > hi) hi = pr; }
      });
    });
    var colors = p.colors.map(function (c) { return { name: c.name, hex: c.hex, hex2: c.hex2, family: c.family, img: img(c.img) }; });
    var model = img(p.model && p.model.img) || null;
    return { real: false, title: p.title, vendor: p.vendor, type: p.type, desc: p.desc, sizes: p.sizes, cell: cell, colors: colors,
             gallery: [], defaultColor: (p.model && p.model.color) || (colors[0] && colors[0].name), modelImg: model,
             specs: p.specs, chart: p.chart, priceMin: lo, priceMax: hi };
  }

  function pdp(el) {
    // Ürün verisi bölümde [data-rb-pdp] kutusunun DIŞINDA (rb-product.liquid sonunda). Yalnız kutunun
    // içine bakılınca gerçek ürün bulunmuyor, sayfa önizleme verisine düşüyordu (28.10.2026).
    var realEl = el.querySelector("script[data-rb-product]") ||
      (el.closest(".rb") || document).querySelector("script[data-rb-product]");
    var real = realEl ? JSON.parse(realEl.textContent) : null;
    if (real && real.color_values && real.color_values.length) { return mountPdp(el, modelFromReal(real, el.getAttribute("data-section-url"))); }
    demo().then(function (d) {
      var key = qs.get("rb_demo") || el.getAttribute("data-demo-default") || Object.keys(d.pdp)[0];
      var p = d.pdp[key] || d.pdp[Object.keys(d.pdp)[0]];
      mountPdp(el, modelFromDemo(p, d));
    }).catch(function () { el.querySelector("[data-rb-pdp-body]").textContent = "Preview data could not be loaded."; });
  }

  // "36:29.90,44.90" -> [{max:36,fee:29.9},{max:null,fee:44.9}]
  function shipTiers(raw) {
    return String(raw || "").split(",").map(function (p) {
      p = p.trim(); if (!p) return null;
      var i = p.lastIndexOf(":"), lim = i > 0 ? parseInt(p.slice(0, i), 10) : null;
      return { max: isNaN(lim) ? null : lim, fee: parseFloat(p.slice(i + 1)) };
    }).filter(function (t) { return t && !isNaN(t.fee); })
      .sort(function (a, b) { return (a.max == null) - (b.max == null) || (a.max || 0) - (b.max || 0); });
  }

  function mountPdp(el, M) {
    var byName = {}; M.colors.forEach(function (c) { byName[c.name] = c; });
    var first = (byName[M.defaultColor] && M.defaultColor) || (byName.Black && "Black") || M.colors[0].name;
    var st = { color: first, qty: {}, main: M.modelImg || null, showAll: false, descOpen: false };
    var body = el.querySelector("[data-rb-pdp-body]"), gal = el.querySelector("[data-rb-gal]");
    var freeOver = parseFloat(el.getAttribute("data-free-over") || "0") || 0;
    var rootEl = el.closest(".rb");

    // başlık alanı (önizlemede JS doldurur)
    var setT = function (sel, v) { var x = rootEl.querySelector(sel); if (x && !M.real) x.textContent = v; };
    setT("[data-rb-title]", M.title); setT("[data-rb-vendor]", M.vendor); setT("[data-rb-title-crumb]", M.title);
    var br = rootEl.querySelector("[data-rb-browse]");
    if (br) br.href = M.real ? (el.getAttribute("data-brand-url") || "/collections/vendors?q={vendor}").replace("{vendor}", encodeURIComponent(M.vendor))
                             : "/collections/all?view=blanks&rb_brand=" + encodeURIComponent(M.vendor);

    function sw(c) { return c.hex ? (c.hex2 ? "linear-gradient(135deg," + c.hex + " 50%," + c.hex2 + " 50%)" : c.hex) : (c.img ? "url(" + c.img + ") center/cover" : "#ddd"); }

    function thumbs() {
      var t = [];
      if (M.modelImg) t.push({ src: M.modelImg, label: "On model" });
      var cur = byName[st.color];
      if (cur && cur.img) t.push({ src: cur.img, label: cur.name, color: cur.name });
      POPULER.concat(M.colors.map(function (c) { return c.name; })).forEach(function (n) {
        var c = byName[n]; if (c && c.img && t.length < 10 && !t.some(function (x) { return x.src === c.img; })) t.push({ src: c.img, label: n, color: n });
      });
      M.gallery.forEach(function (g) { if (g && t.length < 12 && !t.some(function (x) { return x.src === g; })) t.push({ src: g, label: "" }); });
      return t;
    }
    function gallery() {
      gal.textContent = "";
      var list = thumbs(), cur = byName[st.color];
      var main = st.main || (cur && cur.img) || M.modelImg || (list[0] && list[0].src);
      var idx = Math.max(0, list.findIndex(function (t) { return t.src === main; }));
      function pick(t) { if (t.color) { st.color = t.color; st.main = t.src; } else { st.main = t.src; } render(); }
      gal.appendChild(h("div", { class: "rb-gal__main" }, [
        h("span", { class: "rb-dtfbadge", text: "DTF-ready blank" }),
        h("img", { src: main, alt: M.title + " — " + st.color }),
        list.length > 1 ? h("button", { type: "button", class: "rb-gal__nav rb-gal__nav--prev", "aria-label": "Previous image", text: "‹", onclick: function () { pick(list[(idx - 1 + list.length) % list.length]); } }) : null,
        list.length > 1 ? h("button", { type: "button", class: "rb-gal__nav", "aria-label": "Next image", text: "›", onclick: function () { pick(list[(idx + 1) % list.length]); } }) : null
      ]));
      gal.appendChild(h("div", { class: "rb-gal__strip" }, list.map(function (t) {
        return h("button", { type: "button", "aria-label": t.label || "Image", "aria-current": String(t.src === main), onclick: function () { pick(t); } },
          [h("img", { src: t.src, alt: "", loading: "lazy" })]);
      })));
    }

    function render() {
      gallery();
      body.textContent = "";
      // fiyat
      body.appendChild(h("div", { class: "rb-pricerow" }, [
        h("small", { text: "From" }), h("b", { text: money(M.priceMin) }),
        M.priceMax != null && M.priceMax > M.priceMin ? h("span", { class: "rb-range", html: SVG.tag + " " + money(M.priceMin) + "–" + money(M.priceMax) + " by size" }) : null
      ]));
      body.appendChild(h("div", { class: "rb-chips2" }, [
        h("span", { class: "rb-chip2", html: SVG.x + " Blank · no print" }),
        h("span", { class: "rb-chip2 rb-chip2--red", html: SVG.truck + " Ships from our US apparel warehouse" })
      ]));
      // özellikler
      var sp = M.specs || {};
      var specs = [["fabric", "Fabric", sp.fabric], ["weight", "Weight", sp.weight_oz ? sp.weight_oz + " oz" : null], ["fit", "Fit", sp.fit]].filter(function (x) { return x[2]; });
      if (specs.length) body.appendChild(h("div", { class: "rb-specs" }, specs.map(function (x) {
        return h("div", {}, [h("i", { html: SVG[x[0]] }), h("span", {}, [h("small", { text: x[1] }), h("b", { text: x[2] })])]);
      })));

      // renk
      var cur = byName[st.color];
      body.appendChild(h("div", { class: "rb-colorrow" }, [
        h("span", {}, ["Color: ", h("i", { class: "rb-colorrow__sw", style: "--c:" + sw(cur) }), h("b", { text: st.color })]),
        h("span", { class: "rb-count", text: M.colors.length + " colors" })
      ]));
      var LIM = 24, list = st.showAll ? M.colors : M.colors.slice(0, LIM);
      if (!st.showAll && list.indexOf(cur) < 0) list = list.slice(0, LIM - 1).concat([cur]);
      body.appendChild(h("div", { class: "rb-sw2" }, list.map(function (c) {
        var n = Object.keys(st.qty[c.name] || {}).reduce(function (a, k) { return a + st.qty[c.name][k]; }, 0);
        return h("button", { type: "button", class: c.name === st.color ? "is-on" : null, title: c.name, "aria-label": c.name, "aria-pressed": String(c.name === st.color),
          style: "--c:" + sw(c), onclick: function () { st.color = c.name; st.main = c.img || null; render(); } }, n ? [h("em", { text: String(n) })] : []);
      })));
      if (M.colors.length > LIM) body.appendChild(h("button", { type: "button", class: "rb-showall", text: st.showAll ? "Show fewer colors" : "Show all " + M.colors.length + " colors",
        onclick: function () { st.showAll = !st.showAll; render(); } }));

      // bedenler
      body.appendChild(h("div", { class: "rb-sizehead" }, [h("b", { text: "Sizes & quantities" }), h("span", { text: "Mix sizes · no minimums" })]));
      if (!M.cell[st.color] && M.load) {
        body.appendChild(h("div", { class: "rb-loading", text: "Loading sizes for " + st.color + "…" }));
        M.load(st.color).then(render);
      } else {
        var q = st.qty[st.color] || (st.qty[st.color] = {});
        body.appendChild(h("div", { class: "rb-sizes" }, M.sizes.map(function (s) {
          var x = (M.cell[st.color] || {})[s];
          var na = !x || !x.avail, max = x && x.qty != null && x.qty > 0 ? x.qty : 999;
          function set(n) { n = Math.max(0, Math.min(n, max)); if (n) q[s] = n; else delete q[s]; render(); }
          var inp = h("input", { type: "number", min: "0", inputmode: "numeric", value: na ? "" : String(q[s] || 0), placeholder: na ? "–" : null,
            "aria-label": st.color + " " + s + " quantity", disabled: na });
          inp.addEventListener("change", function () { set(parseInt(inp.value || "0", 10) || 0); });
          return h("div", { class: "rb-size" + (na ? " is-na" : "") + (q[s] ? " is-set" : "") }, [
            h("b", { text: s }),
            h("span", { text: na ? "—" : money(x.price) }),
            na ? h("small", { text: "N/A" }) : (x.qty != null && x.qty < 100 ? h("small", { class: "rb-low", text: x.qty + " left" }) : null),
            h("div", { class: "rb-qty" }, [inp, h("span", { class: "rb-qty__btns" }, [
              h("button", { type: "button", "aria-label": "Increase " + s, disabled: na, text: "+", onclick: function () { set((q[s] || 0) + 1); } }),
              h("button", { type: "button", "aria-label": "Decrease " + s, disabled: na || !q[s], text: "−", onclick: function () { set((q[s] || 0) - 1); } })
            ])])
          ]);
        })));
      }

      // toplamlar
      var pcs = 0, total = 0, items = [], lines = [];
      M.colors.forEach(function (c) {
        var bq = st.qty[c.name]; if (!bq) return;
        var n = 0, t = 0, parts = [];
        M.sizes.forEach(function (s) {
          var x = (M.cell[c.name] || {})[s]; if (!bq[s] || !x) return;
          n += bq[s]; t += bq[s] * x.price; parts.push(s + "×" + bq[s]);
          if (x.id) items.push({ id: x.id, quantity: bq[s] });
        });
        if (n) { pcs += n; total += t; lines.push(h("div", {}, [h("span", { text: c.name + " · " + parts.join(", ") }), h("span", { text: money(t) })])); }
      });
      total = Math.round(total * 100) / 100;

      // kargo kutusu
      var ship = el.getAttribute("data-ship-flat"), via = el.getAttribute("data-ship-via") || "";
      var tiers = shipTiers(el.getAttribute("data-ship-tiers"));
      if (tiers.length && pcs) {
        // checkout'taki kargo servisiyle aynı kademe: ≤36 adet / 37+ (ss_order.flat_rate)
        var ti = 0;
        while (ti < tiers.length - 1 && tiers[ti].max != null && pcs > tiers[ti].max) ti++;
        ship = money(tiers[ti].fee) + " flat" + (ti > 0 ? " (" + (tiers[ti - 1].max + 1) + "+ pieces)" : "");
      }
      if (ship || freeOver) {
        var free = freeOver && total >= freeOver;
        var pct = freeOver ? Math.min(100, Math.round(total / freeOver * 100)) : 0;
        var msg = !freeOver ? "" : (free ? "Free blank shipping unlocked" : (total > 0 ? "Add " + money(freeOver - total) + " more for free blank shipping" : ""));
        body.appendChild(h("div", { class: "rb-shipbox" }, [
          h("div", { html: "Blank shipping: <b>" + (free ? "FREE" : (ship || "")) + "</b>" + (via ? " " + via : "") + (freeOver && !free ? " · <b>FREE over " + money(freeOver).replace(".00", "") + "</b>" : "") }),
          freeOver ? h("div", { class: "rb-bar" }, [h("i", { style: "width:" + pct + "%" })]) : null,
          msg ? h("small", { text: msg }) : null
        ]));
      }
      var stext = el.getAttribute("data-ship-text");
      if (stext) body.appendChild(h("div", { class: "rb-shipline", html: SVG.truck + " " }, [stext]));

      var out = h("div", { class: "rb-msg", role: "status" });
      var btn = h("button", { type: "button", class: "rb-btn rb-atc", disabled: !pcs, text: pcs ? "Add " + pcs + (pcs === 1 ? " item" : " items") + " to cart" : "Select sizes & quantities" });
      btn.addEventListener("click", function () {
        if (!M.real) { out.textContent = "Preview: products are not imported yet — in the live store this adds every color and size above to the cart."; return; }
        btn.disabled = true;
        // Temanın yan sepeti (Dawn <cart-drawer>): DTF ürünlerindeki gibi bölümleri aynı istekte
        // isteyip renderContents ile açılır; yoksa eski davranış (mesaj + sepet linki).
        var cd = document.querySelector("cart-drawer");
        var istek = { items: items };
        if (cd && typeof cd.getSectionsToRender === "function") {
          istek.sections = cd.getSectionsToRender().map(function (x) { return x.id; });
          istek.sections_url = window.location.pathname;
        }
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : "/") + "cart/add.js", {
          method: "POST", headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(istek)
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || "Error"); return j; }); })
          .then(function (res) {
            st.qty = {}; render();
            var acildi = false;
            if (cd && res && res.sections && typeof cd.renderContents === "function") {
              try {
                if (cd.classList.contains("is-empty")) cd.classList.remove("is-empty");
                cd.renderContents(res); acildi = true;
              } catch (e) { acildi = false; }
            }
            // PUB_SUB_EVENTS temada üst düzey const: window'a bağlı değil, ortak global kapsamdan okunur.
            if (typeof publish === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
              try { publish(PUB_SUB_EVENTS.cartUpdate, { source: "roll-blanks", cartData: res }); } catch (e) {}
            }
            var m2 = body.querySelector(".rb-msg");
            if (m2) m2.innerHTML = acildi ? "Added to cart." : 'Added to cart. <a href="/cart">View cart →</a>';
          })
          .catch(function (e) { btn.disabled = false; out.style.color = "#b42318"; out.textContent = e.message; });
      });
      body.appendChild(btn);
      body.appendChild(h("div", { class: "rb-totals", html: "<b>" + pcs + "</b> items &nbsp;·&nbsp; Subtotal <b>" + money(total) + "</b>" }));
      if (lines.length > 1) body.appendChild(h("div", { class: "rb-lines2" }, lines));
      body.appendChild(out);

      // açılır bölümler
      function acc(icon, title, content, open) {
        return h("details", { class: "rb-acc2", open: open || null }, [h("summary", { html: SVG[icon] + "<span>" + title + "</span>" }), content]);
      }
      if (M.desc) {
        var d = h("div", { class: "rb-acc2__b rb-desc" + (st.descOpen ? " is-open" : ""), html: M.desc });
        var more = h("button", { type: "button", class: "rb-more", text: st.descOpen ? "Read less" : "Read more", onclick: function () { st.descOpen = !st.descOpen; render(); } });
        body.appendChild(acc("doc", "Description", h("div", {}, [d, more]), true));
      }
      if (sp.features && sp.features.length) body.appendChild(acc("list", "Features", h("ul", { class: "rb-acc2__b" }, sp.features.map(function (f) { return h("li", { text: f }); }))));
      if (M.chart && M.chart.rows && M.chart.rows.length) {
        var tbl = h("table", { class: "rb-tbl rb-chart" }, [
          h("thead", {}, [h("tr", {}, [h("th", { text: "Measurement (" + (M.chart.unit || "in") + ")" })].concat(M.chart.sizes.map(function (s) { return h("th", { text: s }); })))]),
          h("tbody", {}, M.chart.rows.map(function (r) { return h("tr", {}, [h("td", { text: r.name })].concat(r.values.map(function (v) { return h("td", { text: v || "–" }); }))); }))
        ]);
        body.appendChild(acc("ruler", "Size chart", h("div", { class: "rb-acc2__b" }, [h("div", { class: "rb-chartwrap" }, [tbl]),
          h("small", { text: "Garment measurements laid flat, in inches — not body sizes." })])));
      }
      var ret = el.getAttribute("data-returns");
      if (ret) body.appendChild(acc("truck", "Shipping & returns", h("div", { class: "rb-acc2__b", text: ret })));
    }
    render();
  }

  /* ---------- "You may also like" (önizleme) ---------- */
  function demoRec(p, d, base) {
    var m = markup(d), pd = d.pdp[p.handle] || {};
    var sizes = pd.sizes || [];
    var href = base ? base + encodeURIComponent(p.handle) + (qs.get("rb_markup") ? "&rb_markup=" + qs.get("rb_markup") : "") : "#";
    return h("a", { class: "rb-rec", href: href }, [
      h("span", { class: "rb-rec__img" }, [h("img", { src: img(p.img), alt: p.title, loading: "lazy" })]),
      h("span", { class: "rb-rec__dots" }, p.hex.slice(0, 8).map(function (c) { return h("i", { style: "--c:" + c }); })
        .concat(p.colors > 8 ? [h("em", { text: "+" + (p.colors - 8) })] : [])),
      h("span", { class: "rb-rec__row" }, [h("span", {}, [h("small", { text: "As low as" }), h("b", { text: money(raf(p.c_min, m)) })]), h("span", { class: "rb-rec__brand", text: p.vendor })]),
      h("span", { class: "rb-rec__t", text: p.title }),
      h("span", { class: "rb-rec__m", text: p.colors + " colors" + (sizes.length ? " · " + sizes[0] + "–" + sizes[sizes.length - 1] : "") }),
      h("span", { class: "rb-rec__btn", html: "Quick view <span aria-hidden=\"true\">→</span>" })
    ]);
  }

  function init(root) {
    root = root || document;
    fillDemo(root);
    root.querySelectorAll("[data-rb-collection]:not([data-rb-demo])").forEach(function (el) { bindCollection(el, false); });
    root.querySelectorAll("[data-rb-pdp]").forEach(pdp);
  }
  window.RollBlanks = { init: init };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { init(); });
  else init();
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();
